import { Power2, TweenMax } from 'gsap';
import BaseClass from '../../libs/base/BaseClass';

/**
 * プリローダー 管理
 */
export default class PreloaderClass extends BaseClass {
  constructor(_target) {
    super();
    this.name = 'PreloaderClass';
    this.target = _target;
  }

  onShow() {
    TweenMax.killTweensOf(this.target);
    this.target.css({ display: 'block' });
    TweenMax.to(this.target, 1, { opacity: 1, ease: Power2.easeOut });
  }

  onHide() {
    TweenMax.killTweensOf(this.target);
    TweenMax.to(this.target, 1, {
      opacity: 0, ease: Power2.easeOut, onComplete: () => {
        this.target.css({ display: 'none' });
      },
    });
  }
}
